import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

const firebaseConfig =
  process.env.REACT_APP_ENV === "prod"
    ? firebase.initializeApp({
        apiKey: "AIzaSyAy2RcrOV_iNjFUdDoQEgVjWwLi-rMHV6U",
        authDomain: "babbler-4f10a.firebaseapp.com",
        databaseURL: "https://babbler-4f10a.firebaseio.com",
        projectId: "babbler-4f10a",
        storageBucket: "babbler-4f10a.appspot.com",
        messagingSenderId: "961015969356",
        appId: "1:961015969356:web:0111653f60d2b98609e6e9",
        measurementId: "G-ZE6Y1HBR8Q",
    })
    : firebase.initializeApp({
        apiKey: "AIzaSyD76yk11UGSxd_47CTNcohieG4Z0JmmJ_E",
        authDomain: "test-babbler.firebaseapp.com",
        databaseURL: "https://test-babbler.firebaseio.com",
        projectId: "test-babbler",
        storageBucket: "test-babbler.appspot.com",
        messagingSenderId: "943068690104",
        appId: "1:943068690104:web:015444e6c0dc44e9dd264d",
    });

export default firebaseConfig;
